(function () {
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenuLinks = Array.from(document.querySelectorAll('[data-mobile-menu-link]'));
  const desktopDropdowns = Array.from(document.querySelectorAll('[data-header-dropdown]'));
  const menuIcon = mobileToggle?.querySelector('.site-header__mobile-icon--menu');
  const closeIcon = mobileToggle?.querySelector('.site-header__mobile-icon--close');
  let wasMobileMenuOpen = false;

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 64rem)').matches;
  }

  function closeAllDropdowns(exceptDropdown) {
    desktopDropdowns.forEach((dropdown) => {
      if (dropdown !== exceptDropdown) {
        dropdown.open = false;
      }
    });
  }

  desktopDropdowns.forEach((dropdown) => {
    const summary = dropdown.querySelector('summary');
    let closeTimeout;

    if (!summary) return;

    function clearCloseTimeout() {
      if (closeTimeout) {
        window.clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    }

    function openDropdown() {
      if (!isDesktopViewport()) return;
      clearCloseTimeout();
      closeAllDropdowns(dropdown);
      dropdown.open = true;
    }

    function scheduleClose() {
      if (!isDesktopViewport()) return;
      clearCloseTimeout();
      closeTimeout = window.setTimeout(() => {
        if (!dropdown.matches(':focus-within')) {
          dropdown.open = false;
        }
      }, 150);
    }

    dropdown.addEventListener('mouseenter', openDropdown);
    dropdown.addEventListener('mouseleave', scheduleClose);
    dropdown.addEventListener('focusin', openDropdown);
    dropdown.addEventListener('focusout', scheduleClose);

    summary.addEventListener('click', (event) => {
      if (!isDesktopViewport()) return;
      event.preventDefault();
      openDropdown();
    });
  });

  function setMobileMenuOpen(isOpen) {
    if (!mobileMenu || !mobileToggle) return;

    mobileMenu.classList.toggle('is-open', isOpen);
    mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.body.classList.toggle('is-mobile-menu-open', isOpen);

    menuIcon?.classList.toggle('is-hidden', isOpen);
    closeIcon?.classList.toggle('is-hidden', !isOpen);

    mobileMenuLinks.forEach((link) => {
      link.tabIndex = isOpen ? 0 : -1;
    });

    if (wasMobileMenuOpen && !isOpen) {
      mobileToggle.focus();
    }

    wasMobileMenuOpen = isOpen;
  }

  function closeMobileMenu() {
    setMobileMenuOpen(false);
  }

  if (mobileToggle && mobileMenu) {
    mobileMenuLinks.forEach((link) => {
      link.tabIndex = -1;
    });

    mobileToggle.addEventListener('click', () => {
      setMobileMenuOpen(!mobileMenu.classList.contains('is-open'));
    });

    mobileMenuLinks.forEach((link) => {
      link.addEventListener('click', closeMobileMenu);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (mobileMenu?.classList.contains('is-open')) {
        closeMobileMenu();
      }

      closeAllDropdowns();
    }
  });
})();
